import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-models"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "radio" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tipo"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_7 = { for: "document_model" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Modelo de documento", -1)
const _hoisted_11 = { for: "flow_model" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Modelo de fluxo", -1)
const _hoisted_15 = ["id", "checked", "onChange"]
const _hoisted_16 = ["for"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tipo de arquivo"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_19 = ["onMousedown"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome do modelo"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_21 = { class: "content-section" }
const _hoisted_22 = { class: "content-section__header" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Descrição"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_25 = {
  key: 0,
  class: "ai-panel"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "ai-model-prompt" }, "Descreva o que esse modelo deve conter", -1)
const _hoisted_27 = { class: "ai-panel__footer" }
const _hoisted_28 = {
  key: 0,
  class: "ai-panel__quota"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload do modelo"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_31 = { class: "spacing" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_33 = {
  class: "stats",
  for: "stats"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_35 = ["disabled"]

import MySelect from '@/components/select/MySelect.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import ModelFileMimeTypeEnum from '@/enums/ModelFileMimeTypeEnum'
import { computed, onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { OrganizationModel } from '@/models/OrganizationModel'
import ModelInterface, { ModelFileInterface } from '@/models/ModelInterface'
import ModelTypeEnum from '@/enums/ModelTypeEnum'
import { toast } from 'vue3-toastify'
import FileUploader from '@/components/input/FileUploader.vue'
import { AxiosResponse } from 'axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import ModelStatusEnum from '@/enums/ModelStatusEnum'
import { user, hasAiModule } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditModelView',
  props: {
    id: {}
  },
  setup(__props: any) {

const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const props = __props
const deleteFileIds = ref<number[]>([])
const payload = ref<Partial<ModelInterface>>({ organizations: [], files: [] })
const organizations = ref<OrganizationModel[]>()
const isUpdatingDocument = ref(false)

/* AI DESCRIPTION GENERATION */
const isAiPanelOpen = ref<boolean>(false)
const aiPrompt = ref<string>('')
const isGeneratingDescription = ref<boolean>(false)
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()

function getAiUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function generateAiDescription (): void {
  if (!aiPrompt.value.trim() || isGeneratingDescription.value) return

  isGeneratingDescription.value = true

  const body = new FormData()
  body.append('prompt', aiPrompt.value.trim())
  if (payload.value.name) body.append('name', payload.value.name)

  axios.post('/api/models/ai-generate-description', body)
    .then((res) => {
      payload.value.description = res.data.description
      aiPrompt.value = ''
      isAiPanelOpen.value = false
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar a descrição com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isGeneratingDescription.value = false
      getAiUsage()
    })
}
/* AI DESCRIPTION GENERATION */

function getModel () {
  axios.get(`/api/models/${props.id}`)
    .then((res: AxiosResponse<ModelInterface>) => {
      payload.value = { ...res.data, status: res.data.status == ModelStatusEnum.ACTIVE }
    })
}

function getOrganizations () {
  axios.get('/api/organizations')
    .then((res: AxiosResponse<OrganizationModel[]>) => {
      organizations.value = res.data
    })
}

function updateModel () {
  isUpdatingDocument.value = true

  axios.put('/api/models', {
    type: payload.value.type,
    file_mime_type: payload.value.file_mime_type,
    name: payload.value.name,
    description: payload.value.description,
    files: payload.value.files!.filter((file) => file instanceof File),
    model_ids: [payload.value.id],
    organization_ids: payload.value.organizations!.map((org) => org.id),
    status: payload.value.status ? 'active' : 'inactive',
    delete_file_ids: deleteFileIds.value
  })
    .then((res: AxiosResponse<ModelInterface>) => {
      payload.value = { ...res.data, status: res.data.status == ModelStatusEnum.ACTIVE }
      deleteFileIds.value = []
      toast.success('Modelo editado com sucesso')
    })
    .finally(() => isUpdatingDocument.value = false)
}

async function visualizeFile (file: ModelFileInterface): Promise<string> {
  try {
    const response = await axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
    return URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

onMounted(() => {
  getModel()
  getOrganizations()
  getAiUsage()
})

return (_ctx: any,_cache: any) => {
  return (payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          label: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "back"
        }, _hoisted_4),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "type",
                id: "document_model",
                value: _unref(ModelTypeEnum).DOCUMENT_MODEL,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.type) = $event))
              }, null, 8, _hoisted_8), [
                [_vModelRadio, payload.value.type]
              ]),
              _hoisted_9,
              _hoisted_10
            ]),
            _createElementVNode("label", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "type",
                value: _unref(ModelTypeEnum).FLOW_MODEL,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.type) = $event)),
                id: "flow_model"
              }, null, 8, _hoisted_12), [
                [_vModelRadio, payload.value.type]
              ]),
              _hoisted_13,
              _hoisted_14
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("strong", null, "Para qual " + _toDisplayString(isChamber.value ? 'câmara' : 'setor'), 1),
            _createTextVNode(" (obrigatório)")
          ]),
          _createElementVNode("h2", null, "Somente os " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores') + " selecionados irão ter acesso a esse modelo.", 1),
          _createVNode(MyOptions, {
            currentValue: payload.value.organizations?.length ? payload.value.organizations.map(org => org.name).join(', ') : 'Selecione'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (org, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: index
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: 'organization-' + index + 1,
                    name: "organizations",
                    checked: payload.value.organizations?.find((o) => o.id == org.id) ? true : false,
                    onChange: ($event: any) => (($event.target as HTMLInputElement).checked ? payload.value.organizations!.push(org) : payload.value.organizations = payload.value.organizations?.filter((o) => o.id != org.id))
                  }, null, 40, _hoisted_15),
                  _createElementVNode("label", {
                    for: 'organization-' + index + 1
                  }, [
                    _hoisted_17,
                    _createElementVNode("p", null, _toDisplayString(org.name), 1)
                  ], 8, _hoisted_16)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]),
        _createElementVNode("section", null, [
          _hoisted_18,
          _createVNode(MySelect, {
            name: 'model_file_mime_type',
            for: 'model_file_mime_type',
            currentValue: payload.value.file_mime_type ? payload.value.file_mime_type : null
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ModelFileMimeTypeEnum), (type, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onMousedown: ($event: any) => {payload.value.file_mime_type = type;}
                }, _toDisplayString(type), 41, _hoisted_19))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]),
        _createElementVNode("section", null, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Ex: Ofício de solicitação de férias",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.name) = $event))
          }, null, 512), [
            [_vModelText, payload.value.name]
          ])
        ]),
        _createElementVNode("section", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (_unref(hasAiModule))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ai-toggle-button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (isAiPanelOpen.value = !isAiPanelOpen.value))
                }, [
                  _hoisted_24,
                  _createTextVNode(" Gerar com IA ")
                ]))
              : _createCommentVNode("", true)
          ]),
          (_unref(hasAiModule) && isAiPanelOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("textarea", {
                  id: "ai-model-prompt",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((aiPrompt).value = $event)),
                  rows: "2",
                  placeholder: "Ex: Modelo de ofício para solicitar liberação de verba de reforma escolar."
                }, null, 512), [
                  [_vModelText, aiPrompt.value]
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (aiUsage.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(aiUsage.value.remaining) + " de " + _toDisplayString(aiUsage.value.limit) + " gerações restantes hoje", 1))
                    : _createCommentVNode("", true),
                  (!isGeneratingDescription.value)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "button",
                        value: "Gerar descrição",
                        disabled: !aiPrompt.value.trim() || (!!aiUsage.value && aiUsage.value.remaining <= 0),
                        onClick: generateAiDescription
                      }, null, 8, _hoisted_29))
                    : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                        key: 2,
                        height: 40,
                        maxWidth: 160
                      }))
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            name: "",
            id: "",
            cols: "30",
            rows: "10",
            placeholder: "Ex: Modelo de ofício para solicitação de férias para todos os servidores sejam efetivo ou contratados.",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.description) = $event))
          }, null, 512), [
            [_vModelText, payload.value.description]
          ])
        ]),
        _createElementVNode("section", null, [
          _hoisted_30,
          _createVNode(FileUploader, {
            visualizeFile: visualizeFile,
            files: payload.value.files!,
            pushFile: (file) => payload.value.files!.push(file),
            onDelete: _cache[7] || (_cache[7] = (file) => deleteFileIds.value.push(file.id))
          }, null, 8, ["files", "pushFile"])
        ]),
        _createElementVNode("section", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("label", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "stats",
              id: "stats",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.status) = $event))
            }, null, 512), [
              [_vModelCheckbox, payload.value.status]
            ]),
            _hoisted_34
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingDocument.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Salvar",
                onClick: updateModel,
                disabled: !payload.value.type || !payload.value.organizations?.length || !payload.value.file_mime_type || !payload.value.name || !payload.value.description || !payload.value.files?.length
              }, null, 8, _hoisted_35))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.go(-1)))
          })
        ])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})